var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"h-footer"},[_vm._v(" Copyright© h365 all rights reserved 2021. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }